const valuesColors = {
  VALUES_50: '#F3E3EE',
  VALUES_100: '#E2B9D5',
  VALUES_200: '#CE8BBA',
  VALUES_500: '#9B107D',
}

export default valuesColors
